var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.25C4.2735 5.25 2.25 7.2735 2.25 9.75C2.25091 10.4587 2.41917 11.1571 2.74109 11.7884C3.063 12.4197 3.52947 12.9661 4.1025 13.383C2.1225 14.3655 0.75 16.398 0.75 18.75H2.25C2.25 16.2555 4.2555 14.25 6.75 14.25C9.2445 14.25 11.25 16.2555 11.25 18.75H12.75C12.75 16.2555 14.7555 14.25 17.25 14.25C19.7445 14.25 21.75 16.2555 21.75 18.75H23.25C23.25 16.398 21.8775 14.3655 19.8975 13.383C20.4706 12.9662 20.9371 12.4198 21.2591 11.7885C21.581 11.1571 21.7492 10.4587 21.75 9.75C21.75 7.2735 19.7265 5.25 17.25 5.25C14.7735 5.25 12.75 7.2735 12.75 9.75C12.7509 10.4587 12.9192 11.1571 13.2411 11.7884C13.563 12.4197 14.0295 12.9661 14.6025 13.383C13.5061 13.9209 12.5987 14.7786 12 15.843C11.4013 14.7786 10.4939 13.9209 9.3975 13.383C9.97062 12.9662 10.4371 12.4198 10.7591 11.7885C11.081 11.1571 11.2492 10.4587 11.25 9.75C11.25 7.2735 9.2265 5.25 6.75 5.25ZM6.75 6.75C8.415 6.75 9.75 8.085 9.75 9.75C9.75 11.415 8.415 12.75 6.75 12.75C5.085 12.75 3.75 11.415 3.75 9.75C3.75 8.085 5.085 6.75 6.75 6.75ZM17.25 6.75C18.915 6.75 20.25 8.085 20.25 9.75C20.25 11.415 18.915 12.75 17.25 12.75C15.585 12.75 14.25 11.415 14.25 9.75C14.25 8.085 15.585 6.75 17.25 6.75Z",
    fill: "none",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/Teams.613a1819010325dffaac803d35bdd1ba.svg";
export { ForwardRef as ReactComponent };